import React, { useEffect } from 'react';
import styles from 'src/app/surveys/views/new-survey-design/NewSurveyDesign.module.scss';
import useCustomer from 'src/app/customers/hooks/useCustomer';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import { useAppDispatch } from 'src/store';
import { useAppSelector } from 'src/store';
import useProject from 'src/shared/hooks/useProject';
import Loader from 'src/shared/components/loader/Loader';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { reset } from 'src/app/habitat-insights/state/habitatInsightsUploadSlice';
import useHabitatInsightsUpload from 'src/app/habitat-insights/views/habitat-insights-details/components/habitat-insights-upload/hooks/useHabitatInsightsUpload';
import { getCurrentHabitatInsightsUploadFormState } from 'src/app/habitat-insights/state/habitatInsightsUploadSelector';
import { SubscriptionType, Access } from 'src/shared/types';
import HabitatInsightsUpload from './components/habitat-insights-upload/HabitatInsightsUpload';
import BasicInformation from './components/basic-information/BasicInformation';
import CustomerContacts from './components/customer-contacts/CustomerContacts';
export const HabitatInsightsDetails = () => {
    const formState = useAppSelector(getCurrentHabitatInsightsUploadFormState);
    const dispatch = useAppDispatch();
    const { currentCustomerId } = useCustomer();
    const { currentProjectDefinition, currentProjectId } = useProject();
    const navigate = useAppNavigation();
    const { enableUpload, onFormChange } = useHabitatInsightsUpload();
    const title = currentProjectId ? 'Update Habitat Insights' : 'New Habitat Insights';

    useEffect(() => {
        if (!currentCustomerId) {
            navigate.toCustomers();
        }

        dispatch(reset());

        onFormChange({ customerId: currentCustomerId });
        if (currentProjectId && currentProjectDefinition) {
            onFormChange({
                projectId: currentProjectId,
                projectName: currentProjectDefinition?.projectName,
                customerId: currentCustomerId,
                formMode: Access.UPDATE,
                subscriptionType: SubscriptionType.SURVEY_WITH_HABITAT_INSIGHTS,
                country: currentProjectDefinition?.country,
            });
        }
    }, [currentCustomerId, currentProjectId, currentProjectDefinition]);

    const mainContent = (
        <div className='h-full overflow-auto pb-[50px]'>
            <div className={styles.formView}>
                <div className={styles.formViewTitle}>Habitat Insight details</div>
                <BasicInformation />
                <CustomerContacts />
            </div>
            {enableUpload && (
                <div className='mt-10'>
                    <HabitatInsightsUpload />
                </div>
            )}
        </div>
    );
    return (
        <>
            {formState.loading && (
                <div className='fixed inset-0 w-full h-full bg-white/80 flex items-center justify-center z-[1000]'>
                    <Loader />
                </div>
            )}
            <StandardAppLayout mainContent={mainContent} title={title} />
        </>
    );
};

export default HabitatInsightsDetails;
